// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBookingSearchResponse

import { hydrateAdminBookingListItem, type AdminBookingListItem, type AdminBookingListItemApiResponse } from './adminBookingListItem.gen';

export type AdminBookingSearchApiResponse = {
	items: AdminBookingListItemApiResponse[];
};

export type AdminBookingSearch = {
	items: AdminBookingListItem[];
};

export function hydrateAdminBookingSearch(data: AdminBookingSearchApiResponse): AdminBookingSearch {
	return {
		...data,
		items: data.items.map(hydrateAdminBookingListItem),
	};
}